import { prefixerC } from '.'

export const ROUTE_NIVEL_APROBACION_FLUJO_PAGO = prefixerC('nivel-aprobacion-flujo-pago')
export const ROUTE_PERMISO_CUENTA_BANCARIA = prefixerC('permiso-cuenta-bancaria')
